import { Injectable } from '@angular/core';

@Injectable()
export class TranslationDictionaryService {
  constructor() {}

  lookupByKey(survey, dictionary, key) {
    if (
      typeof survey !== 'undefined' &&
      typeof survey.i18 !== 'undefined' &&
      typeof survey.i18.dictionary !== 'undefined' &&
      typeof survey.i18.dictionary[dictionary] !== 'undefined' &&
      typeof survey.i18.dictionary[dictionary][key] !== 'undefined'
    ) {
      return survey.i18.dictionary[dictionary][key];
    } else {
      return false;
    }
  }

  getKeyText(key, code) {
    if (
      typeof key !== 'undefined' &&
      typeof key.labels !== 'undefined' &&
      typeof key.labels[code] !== 'undefined' &&
      typeof key.labels[code].text !== 'undefined'
    ) {
      return key.labels[code].text;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/translation-dictionary-service.ts